import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: '',
    description: 'Header for unknown error',
    defaultMessage: 'Can\'t continue because something went wrong',
  },
  fileHeader: {
    id: '',
    description: 'Header for file-upload error',
    defaultMessage: 'Couldn\'t upload file',
  },
  instructions: {
    id: '',
    description: 'Instructions for unknown error',
    defaultMessage: 'Click Cancel and try again later.',
  },
  sadCat: {
    id: '',
    description: 'Alt for sad cat',
    defaultMessage: 'Sad Cat Image',
  },
});

export default messages;
